<div class="title">Ubicación</div>
<div class="view-map">
  <button mb-button variant="principal" color="secondary" (click)="openModalMap()">
    <mb-icon icon="pointer"></mb-icon>
    <span i18n="@@ver_mapa">Ver mapa</span>
  </button>
</div>
<mb-icon-text class="address">
  <mb-icon icon="pointer"></mb-icon>
  <span>{{ hotelStatic.address }}, {{ hotelStatic.city.name }}</span>
</mb-icon-text>
